import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { posCatalogControllerGetCatalog } from '@klubovna/api-client';
import { PosCatalogDto } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PosCatalogApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  getCatalog(): Observable<PosCatalogDto> {
    return posCatalogControllerGetCatalog(this.http, this.apiConfig.rootUrl)
      .pipe(map(response => response.body as PosCatalogDto));
  }
}
